import { Component, ViewEncapsulation } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { DateFormats } from 'src/app/models/dates/date-formats';
import { BillsInclusiveTypes } from 'src/app/models/property/bills-inclusive-types';
import { WidgetRoomOverview } from 'src/app/models/property/widget-room-overview';
import { RentPaymentFrequencies } from 'src/app/models/tenancy/rent-payment-frequencies';
import { WidgetRoom } from '../../../models/property/widget-room';
import {LazyLoaderService} from "../../../services/lazy-loader.service";
import {zip} from "rxjs";
import {DateString8601} from "../../../models/primitive-types";
import {DateTime} from "luxon";

@Component({
    encapsulation: ViewEncapsulation.None,
    templateUrl: './widget-rooms.page.html'
})
export class WidgetRoomsPage {

    roomsOverview: WidgetRoomOverview;

    RentPaymentFrequencies = RentPaymentFrequencies;
    BillsInclusiveTypes = BillsInclusiveTypes;
    DateFormats = DateFormats;

    showPrice: boolean = true;

    nowDate: DateString8601 = DateTime.now().toISO();

    constructor(private activatedRoute: ActivatedRoute, private lazyLoaderService: LazyLoaderService) {
        zip(this.activatedRoute.data, this.activatedRoute.queryParams).subscribe(([data, params]) => {
            this.roomsOverview = data['rooms'];
            this.showPrice = params['showPrice'];
        });

        this.lazyLoaderService.loadIFrameResizer()
            .subscribe();
    }
}
